import { useState } from 'react';
import './StarRating.css';

type Props = {
  value: number | null;
  onChange?: (rating: number) => void;
  label?: string;
  size?: 'small' | 'large';
};

const StarRating = ({ value, onChange, label = 'Rating', size = 'large' }: Props) => {
  const [hoverValue, setHoverValue] = useState<number | null>(null);
  const displayValue = hoverValue ?? value ?? 0;

  return <div className={`star-control star-control--${size}`} onMouseLeave={() => setHoverValue(null)} aria-label={value ? `${label}: ${value} out of 5` : `${label}: not rated`}>
    {[0, 1, 2, 3, 4].map(index => {
      const leftValue = index === 0 ? 1 : index + 0.5;
      const rightValue = index + 1;
      const fill = Math.max(0, Math.min(1, displayValue - index)) * 100;
      return <span className="star-control__star" style={{ '--star-fill': `${fill}%` } as React.CSSProperties} key={index}>
        ★
        {onChange && <>
          <button type="button" className="star-control__hit star-control__hit--left" aria-label={`${leftValue} out of 5`} onMouseEnter={() => setHoverValue(leftValue)} onFocus={() => setHoverValue(leftValue)} onClick={() => onChange(leftValue)} />
          <button type="button" className="star-control__hit star-control__hit--right" aria-label={`${rightValue} out of 5`} onMouseEnter={() => setHoverValue(rightValue)} onFocus={() => setHoverValue(rightValue)} onClick={() => onChange(rightValue)} />
        </>}
      </span>;
    })}
    {onChange && <output className="star-control__value">{displayValue ? displayValue.toFixed(1) : '—'}</output>}
  </div>;
};
export default StarRating;
